export default __webpack_public_path__ + "static/media/room.b4eadef8.svg";